/* eslint-disable prefer-destructuring */
import { mappingCompanySlugToName } from '@/utils/airlineMapping';
import { toSlug } from '@/utils/common';
import { genLinkSeo } from '@/utils/genLinkSeo';
import { pr } from '@/utils/pxToRem';
import { Stack, Link } from '@mui/material';
import React from 'react';

const listCompany = ['vietnam-airlines', 'vietjet-air', 'bamboo-airways', 'vietravel-airlines', 'pacific-airlines'];

interface SectionOtherCompanyProps {
  company: string;
  startPoint: any;
  toPoint: any;
  isDesktop?: boolean;
}

const SectionOtherCompany: React.FC<SectionOtherCompanyProps> = ({
  company,
  startPoint,
  toPoint,
  isDesktop,
}) => {
  const otherCompany = listCompany.filter((item) => item !== company);
  return (
    <Stack
      spacing="16px"
      direction={isDesktop ? 'row' : 'column'}
      justifyContent="space-between"
      marginTop={pr`16px`}
    >
      {otherCompany.map((com) => {
        let airline = mappingCompanySlugToName(com);
        if (!airline.includes('Vietnam Airlines') && !airline.includes('Vietravel Airlines')) {
          airline = airline.split(' ')[0];
        }
        return (
          <Link
            sx={{
              fontWeight: 500,
              textDecoration: isDesktop ? 'none' : 'underline',
            }}
            href={genLinkSeo({
              startName: startPoint?.location,
              startId: startPoint?.id,
              startStateName: startPoint?.stateName,
              endName: toPoint?.location,
              endId: toPoint?.id,
              endStateName: toPoint?.stateName,
              company: com,
            })}
            // href={`/vn/ve-may-bay/${com}${startPoint ? `-tu-${toSlug(
            //   startPoint.location,
            // )}` : ''}-di-${toSlug(toPoint?.location)}${startPoint ? `.${startPoint.id}` : ''}.${
            //   toPoint.id
            // }.vi`}
            key={com}
          >
            {` Vé máy bay 
            ${airline}
            ${startPoint ? `từ 
            ${startPoint.location}` : ''}
            đi 
            ${toPoint.location}
            `}
          </Link>
        );
      })}
    </Stack>
  );
};

export default SectionOtherCompany;
